<div class="additional-information">
    <kendo-grid #detailGrid
                [data]="gridDataResult"
                scrollable="false"
                hideHeader="true"
                [loading]="loading"
    >
        <kendo-grid-column field="name">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="value">{{ dataItem.name }} ({{ dataItem.data.length }})</span>
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="this.hasChildTableRecords">
            <kendo-grid #childTableGrid
                [data]="dataItem.data"
                scrollable="false"
                resizable="true"
            >
                <kendo-grid-column *ngFor="let colData of dataItem.columns" field="{{colData.name}}" title="{{colData.name}}" autoSize="true">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="value">{{ dataItem[colData.name] }}</span>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </ng-template>
        
        <kendo-grid-messages noRecords="">
        </kendo-grid-messages>
    </kendo-grid>
</div>
